/**
 * @generated SignedSource<<032f9d14438572b8303cbd318ea16250>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentType } from "relay-runtime";
declare export opaque type AgentsCount_organization$fragmentType: FragmentType;
export type AgentsCount_organization$data = {|
  +agents: ?{|
    +count: number,
  |},
  +id: string,
  +uuid: string,
  +$fragmentType: AgentsCount_organization$fragmentType,
|};
export type AgentsCount_organization$key = {
  +$data?: AgentsCount_organization$data,
  +$fragmentSpreads: AgentsCount_organization$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentsCount_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentConnection",
      "kind": "LinkedField",
      "name": "agents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node/*: any*/).hash = "7762e5e7b3495dd73db2c76497751a3d";

module.exports = ((node/*: any*/)/*: Fragment<
  AgentsCount_organization$fragmentType,
  AgentsCount_organization$data,
>*/);
